import { appRoutes, TipoUtenteEnum, userRegistrationMessages, useUserRegistrationPageLogic } from 'azshared';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { AppButton } from '../../../components/buttons/app-button';
import { Card } from '../../../components/card/card';
import { AppRadioButtonProps } from '../../../components/radio/app-radio-button';
import { AppRadioGroup } from '../../../components/radio/app-radio-group';
import { useGlobalActions } from '../../../hooks/global-actions';
import { LoginContainer } from '../login-container/login-container';
import './user-registration-page.scss';
import { BannerCookiePolicy } from 'src/components/banner-cookie-policy/banner-cookie-policy';
import { useNavigate } from 'react-router-dom';

export const UserRegistrationPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { selectedOptionUserType, goAhead, onSelectedOptionChanged, buttonDisabled } = useUserRegistrationPageLogic(useGlobalActions());

  const userRegistrationOptions: AppRadioButtonProps[] = [
    {
      value: TipoUtenteEnum.Pf,
      label: formatMessage(userRegistrationMessages.labelNaturalPersonRadioButton)
    },
    {
      value: TipoUtenteEnum.Pg,
      label: formatMessage(userRegistrationMessages.labelLegalPersonRadioButton)
    },
    {
      value: TipoUtenteEnum.Fid,
      label: formatMessage(userRegistrationMessages.labelFiduciariaRadioButton)
    }
  ];

  const handleClickGoBack = useCallback(() => {
    navigate(appRoutes.Login);
  }, [navigate]);

  return (
    <>
      <LoginContainer>
        <div className='user-registration'>
          <Card
            title={formatMessage(userRegistrationMessages.pageTitle)}
            subtitle={formatMessage(userRegistrationMessages.pageSubtitle)}
            clickGoBack={handleClickGoBack}
            back={formatMessage(userRegistrationMessages.backTo)}>
            <div className='radio-button'>
              <AppRadioGroup options={userRegistrationOptions} selectedValue={selectedOptionUserType} onSelectedValueChanged={onSelectedOptionChanged} />
            </div>
            <div className='button'>
              <AppButton label={formatMessage(userRegistrationMessages.buttonUserRegistration)} onClick={goAhead} disabled={buttonDisabled} />
            </div>
          </Card>
        </div>
      </LoginContainer>
      <BannerCookiePolicy />
    </>
  );
};
